
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/communitiesguidelines",
      function () {
        return require("private-next-pages/communitiesguidelines/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/communitiesguidelines"])
      });
    }
  